import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Modal, Button, Input } from 'antd';
import BaseRadioList from '@/components/Elements/BaseRadios';
import BaseSelect from '@/components/Elements/BaseSelect';
import { isMobile } from 'react-device-detect';
import { createProject, updateProject } from '@/redux/actions/projectActions';
import { _newLine } from '@/utils/helpers';

class ProjectForm extends Component {
    constructor() {
        super();
        this.state = {

        };
    }
    componentDidMount() {

    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    if (this.props.currentItem) {
                        await this.props.updateProject(this.props.currentItem.id, values);
                        this.onClose();
                    } else {
                        await this.props.createProject(values);
                        this.props.form.resetFields();
                    }
                } catch (requestError) {
                    // Action đã hiển thị thông báo lỗi; giữ form để người dùng chỉnh dữ liệu.
                }
            }
        });
    }

    onClose() {
        this.props.onCancel();
        this.props.form.resetFields();
    }

    render() {
        var { visible, currentItem, users } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Modal
                visible={visible}
                title={currentItem ? "Sửa bản ghi" : "Tạo mới bản ghi"}
                onOk={(e) => this.submit(e)}
                onCancel={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '35%'}
                footer={[
                    <Button key="back" onClick={() => this.onClose()}>
                        Huỷ
                    </Button>,
                    <Button key="submit" type="primary" onClick={(e) => this.submit(e)}>
                        {currentItem ? "Cập nhật" : "Tạo"}
                    </Button>,
                ]}
            >
                {visible ?
                    <Form layout='vertical'>
                        <Form.Item label="Tên dự án">
                            {getFieldDecorator('name', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Vui lòng điền!',
                                    },
                                ],
                                initialValue: currentItem ? currentItem.name : ""
                            })(<Input />)}
                        </Form.Item>
                        <Form.Item label="Người phụ trách">
                            {getFieldDecorator('person_charge_id', {
                                rules: [
                                    {
                                        required: false,
                                        message: 'Field is required.'
                                    }
                                ],
                                initialValue: currentItem ? currentItem.person_charge_id : ""
                            })(
                                <BaseSelect
                                    options={users}
                                    optionValue="user_id"
                                    optionLabel="display_name"
                                    defaultText="Chọn người phụ trách"
                                    showSearch={true}
                                    style={{ width: '100%' }}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Ghi chú">
                            {getFieldDecorator('note', {
                                rules: [
                                    {
                                        required: false,
                                        message: "Vui lòng điền!",
                                    },
                                ],
                                initialValue: currentItem ? _newLine(currentItem.note) : ""
                            })(
                                <Input.TextArea />
                            )}
                        </Form.Item>
                        <Form.Item label="Tình trạng">
                            {getFieldDecorator('project_status', {
                                rules: [
                                    {
                                        required: true,
                                        message: "Vui lòng chọn!",
                                    },
                                ],
                                initialValue: currentItem ? currentItem.project_status : 0
                            })(
                                <BaseRadioList
                                    options={[
                                        { value: 1, label: 'Đã hoàn thành' },
                                        { value: 0, label: 'Chưa hoàn thành' },
                                    ]}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Trạng thái">
                            {getFieldDecorator('status', {
                                rules: [
                                    {
                                        required: true,
                                        message: "Vui lòng chọn!",
                                    },
                                ],
                                initialValue: currentItem ? currentItem.status : 1
                            })(
                                <BaseRadioList
                                    options={[
                                        { label: "Kích hoạt", value: 1 },
                                        { label: "Chưa kích hoạt", value: 0 }
                                    ]}
                                />
                            )}
                        </Form.Item>
                    </Form>
                    : null}
            </Modal>
        )
    }
}

function mapStateToProps(state) {
    return {
        users: state.config.users
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createProject: (data) => dispatch(createProject(data)),
        updateProject: (id, data) => dispatch(updateProject(id, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ProjectForm' })(ProjectForm));
